

































































































































import { Component, Prop, Vue } from "vue-property-decorator";
//import Vue from 'vue'
//import VueYoutube from 'vue-youtube'

//Vue.use(VueYoutube)

interface Album {
  player: string;
  title: string;
  url: string;
  videoUrl: string;
  items: Array<Item>;
  comment: Comment;
}
interface Item {
  id: string;
  comment: string;
  title: string;
  type: string;
}
interface Comment {
  id: string;
  title: string;
  pictures: Array<Picture>;
  description: Array<Description>
}
interface Picture {
  id: string;
  comment: string;
  title: string;
  type: string;
}
interface Description {
  id: string;
  title: string;
  descriptions: Array<string>;
}

@Component
export default class ProductWorld extends Vue {

  @Prop()
  private msg!: string;
  albumIndex = 0;
  albumTitle = "";
  videoIndex = 0;
  videoComment = '';
  videoTitle = 'VID_20191116_133012';
  
  videoSrc = 'http://www.hiroict.com/files/talkai/ビデオ/トークA愛/トークA/ダンス教習ビデオ/ルンバ/VID_20191116_133012.mp4';
  pictureUrl = 'http://www.hiroict.com/files/talkai/ビデオ/トークA愛/製品紹介/ダンス音楽の利用/Screenshot_20200708_084738_com.hiroict.talkai.cast.smarthome.jpg';

  product_1:Album = {
    player : '製品紹介',
    title: 'ダンス音楽の利用',
    url : 'http://www.hiroict.com/files/talkai/ビデオ/トークA愛/製品紹介/',
    videoUrl : 'http://www.hiroict.com/files/talkai/ビデオ/トークA愛/トークA/ダンス教習ビデオ/ルンバ/',
    items: [
        {id: '1', comment:'トークAのルンバ（初級）', title: 'VID_20191116_133012', type:'mp4'},
           ],
    comment:{
      id: '1',
      title:'ダンス音楽の利用例（ワルツの場合）',
      pictures: [
        {id: '1', comment:'最初の画面', title: 'Screenshot_20200708_084738_com.hiroict.talkai.cast.smarthome', type:'jpg'},
        {id: '2', comment:'手動操作：「ダンス音楽→トークA→木曜日スポーツセンター用→04 ワルツ（魅惑のワルツ）」を選択します。', title: 'Screenshot_20200708_104153_com.hiroict.talkai.cast.smarthome', type:'jpg'},
        {id: '3', comment:'手動操作：「ダンス音楽→トークA→木曜日スポーツセンター用→04 ワルツ（魅惑のワルツ）」を演奏します。', title: 'Screenshot_20200708_104208_com.hiroict.talkai.cast.smarthome', type:'jpg'},
        {id: '4', comment:'音声操作：「マイク（off）」ボタンを押します。→「マイク（on）」になります。', title: 'Screenshot_20200708_114401_com.hiroict.talkai.cast.smarthome', type:'jpg'},
        {id: '5', comment:'音声操作：「行かないで」なるWakup Wordを言います。→「お話ください」と言うダイヤログが表示されます。', title: 'Screenshot_20200708_114417_com.hiroict.talkai.cast.smarthome', type:'jpg'},
        {id: '6', comment:'音声操作：「ワルツ」なる演奏したい曲名を言います。→「検索結果」がダイヤログに表示されます。', title: 'Screenshot_20200708_114437_com.hiroict.talkai.cast.smarthome', type:'jpg'},
        {id: '7', comment:'音声操作：「一番」なるメニュー番号を言います。→「04 ワルツ（魅惑のワルツ）」が演奏されます。', title: 'Screenshot_20200708_114458_com.hiroict.talkai.cast.smarthome', type:'jpg'},
        {id: '8', comment:'音声操作：演奏中でも「行かないで」なるWakup Wordの後で「次の曲」と言えば、次の曲が演奏されます。', title: 'Screenshot_20200709_092747_com.hiroict.talkai.cast.smarthome', type:'jpg'},
      
      ],
      description: [
         {
          id: '1.1',
	      title: '説明',
	      descriptions: [
	           'ダンスは、ダンス音楽で踊るものです。',
	           'ダンスは、ダンス音楽に合わせて、正確に踊れるように何度も練習をする必要があります。',
	           '特に、ワルツは、足の位置の誤差が10cm以内になるように練習する必要があります。',
	           '「トークA愛 for お稽古」は、ダンス音楽に合わせて、何度も練習できる機能を提供します。',
	       ],
         },
         {
          id: '1.2',
	      title: '操作例',
	      descriptions: [
	           '【手動の場合】',
	           '①アプリを起動します。',
	           '②最初のメニュー画面を表示します。',
	           '③左側のメニューで「ダンス音楽→トークA」を選択します。',
	           '④右側のメニューで「木曜日スポーツセンター用→ワルツ（魅惑のワルツ）」を選択します。',
	           '⑤「魅惑のワルツ」が演奏されます。',
	           '⑥「魅惑のワルツ」の演奏に合わせて、練習を開始します。',
	           '【音声の場合】',
	           '①アプリを起動します。マイク入力はONにしておきます。',
	           '②音声で「行かないで」と言う「Wakeup Word」を言います。',
	           '③「お話ください」と言うダイヤログが表示されるので、音声で「ワルツ」と言います。',
	           '④ダイヤログに「ワルツ」を含むコンテンツ一覧が表示されるので、音声で「一番」と言います。',
	           '④「04 ワルツ（魅惑のワルツ）」が演奏されます。',
	           '⑤演奏中でも「行かないで」なるWakup Wordの後で「次の曲」と言えば、次の曲が演奏されます。',
	           '⑥「次の曲」以外に「前の曲」「中断」「再開」「もう一度」のような演奏制御用の言葉を使用することができます。',
	       ],
         },
       ],
    },
  };
  product_2:Album = {
    player : '製品紹介',
    title: 'ダンス動画の利用',
    url : 'http://www.hiroict.com/files/talkai/ビデオ/トークA愛/製品紹介/',
    videoUrl : 'http://www.hiroict.com/files/talkai/ビデオ/トークA愛/トークA/ダンス教習ビデオ/チャチャチャ/',
    items: [
        {id: '1', comment:'トークAのルンバ（初級）', title: 'VID_20191116_133356', type:'mp4'},
        {id: '2', comment:'トークAのルンバ（初級）', title: 'VID_20191116_133758', type:'mp4'},
           ],
    comment:{
      id: '1',
      title:'ダンス動画の利用（ワルツの場合）',
      pictures: [
        {id: '1', comment:'手動操作：「ダンス動画→ワルツ」を選択します。', title: 'Screenshot_20200708_160236_com.hiroict.talkai.cast.smarthome', type:'jpg'},
        {id: '2', comment:'手動操作：「ダンス動画→ワルツ→Natural Spin Turn(123, 456)→PreBronze Waltz Natural Spin Turn」を選択します。', title: 'Screenshot_20200708_160251_com.hiroict.talkai.cast.smarthome', type:'jpg'},
        {id: '3', comment:'手動操作：「ダンス動画→ワルツ→Natural Spin Turn(123, 456)→PreBronze Waltz Natural Spin Turn」を演奏します。', title: 'Screenshot_20200708_160315_com.hiroict.talkai.cast.smarthome', type:'jpg'},
        {id: '4', comment:'音声操作：「マイク（off）」ボタンを押します。→「マイク（on）」になります。', title: 'Screenshot_20200708_161455_com.hiroict.talkai.cast.smarthome', type:'jpg'},
        {id: '5', comment:'音声操作：「行かないで」なるWakup Wordを言います。→「お話ください」と言うダイヤログが表示されます。', title: 'Screenshot_20200708_161532_com.hiroict.talkai.cast.smarthome', type:'jpg'},
        {id: '6', comment:'音声操作：「ナチュラル スピン ターン」なる練習したステップ名を言います。→「検索結果」がダイヤログに表示されます。', title: 'Screenshot_20200708_161543_com.hiroict.talkai.cast.smarthome', type:'jpg'},
        {id: '7', comment:'音声操作：「二番」なるメニュー番号を言います。→「ナチュラル スピン ターン 群馬県の社交ダンス教室」が演奏されます。', title: 'Screenshot_20200708_161627_com.hiroict.talkai.cast.smarthome', type:'jpg'},
      
      ],
      description: [
         {
          id: '1.1',
	      title: '説明',
	      descriptions: [
	           'ダンスは、フィガー（figure）の組み合わせです。',
	           'フィガー（figure）の組み合わせは、アマルガメーション（Amalgamations）と呼ばれます。',
	           'ダンス教室によって、アマルガメーション（Amalgamations）は、少しづつ違いますが、フィガー（figure）は共通です。',
	           '従って、フィガー（figure）を「ダンス動画」を見ながら覚えれば、ダンスが上達できます。',
	           '「トークA愛 for お稽古」は、ダンス動画見ながら、フィガー（figure）を覚える機能を提供します。',
	       ],
         },
         {
	      id: '1.2',
	      title: '操作例',
	      descriptions: [
	           '【手動の場合】',
	           '①アプリを起動します。',
	           '②最初のメニュー画面を表示します。',
	           '③左側のメニューで「ダンス動画→ワルツ」を選択します。',
	           '④右側のメニューで「Natural Spin Turn(123, 456)→PreBronze Waltz Natural Spin Turn」を選択します。',
	           '⑤「PreBronze Waltz Natural Spin Turn」の動画が演奏されます。',
	           '⑥「PreBronze Waltz Natural Spin Turn」の動画を見て、練習を開始します。',
	           '⑦「Natural Spin Turn」の文字による説明は「歌詞」ボタンを押します。',
	           '⑧「Natural Spin Turn」の音声による説明は「歌詞（音声）」ボタンを押します。',
	           '【音声動の場合】',
	           '①アプリを起動します。',
	           '②音声で「行かないで」と言う「Wakeup Word」を言います。',
	           '③「お話ください」と言うダイヤログが表示されるので、音声で「ナチュラル スピン ターン」と言います。',
	           '④ダイヤログに「ナチュラル スピン ターン」を含むコンテンツ一覧が表示されるので、音声で「二番」と言います。',
	           '⑤「ナチュラル スピン ターン 群馬県の社交ダンス教室」が演奏されます。',
	           '⑥「ナチュラル スピン ターン 群馬県の社交ダンス教室」の動画を見て、練習を開始します。',
	           '⑦「Natural Spin Turn」の文字による説明は「歌詞」ボタンを押します。',
	           '⑧「Natural Spin Turn」の音声による説明は「歌詞（音声）」ボタンを押します。',
	       ],
	   }],
    },
  };
  product_3:Album = {
    player : '製品紹介',
    title: 'カラオケ動画の利用',
    url : 'http://www.hiroict.com/files/talkai/ビデオ/トークA愛/製品紹介/',
    videoUrl : 'http://www.hiroict.com/files/talkai/ビデオ/トークA愛/トークA/ダンス教習ビデオ/チャチャチャ/',
    items: [
        {id: '1', comment:'トークAのルンバ（初級）', title: 'VID_20191116_133356', type:'mp4'},
        {id: '2', comment:'トークAのルンバ（初級）', title: 'VID_20191116_133758', type:'mp4'},
           ],
    comment:{
      id: '1',
      title:'カラオケ動画の利用（「行かないで」の場合）',
      pictures: [
        {id: '1', comment:'手動操作：最初の画面（左）で「カラオケ動画（男性）→玉置浩二」を選択。', title: 'Screenshot_20200708_153534_com.hiroict.talkai.cast.smarthome', type:'jpg'},
        {id: '2', comment:'手動操作：最初の画面（右）で「カラオケ動画（男性）→玉置浩二→行かないで」を選択。「演奏開始」ボタンを押す。', title: 'Screenshot_20200708_153545_com.hiroict.talkai.cast.smarthome', type:'jpg'},
        {id: '3', comment:'手動操作：次の画面で「カラオケ動画（男性）→玉置浩二→行かないで」が演奏開始。', title: 'Screenshot_20200708_153552_com.hiroict.talkai.cast.smarthome', type:'jpg'},
        {id: '4', comment:'音声操作：「マイク（off）」ボタンを押します。→「マイク（on）」になります。', title: 'Screenshot_20200708_192558_com.hiroict.talkai.cast.smarthome', type:'jpg'},
        {id: '5', comment:'音声操作：「行かないで」なるWakup Wordを言います。→「お話ください」と言うダイヤログが表示されます。', title: 'Screenshot_20200708_192740_com.hiroict.talkai.cast.smarthome', type:'jpg'},
        {id: '6', comment:'音声操作：「行かないで」と言う曲名を言います。→「検索結果」がダイヤログに表示されます。', title: 'Screenshot_20200708_192758_com.hiroict.talkai.cast.smarthome', type:'jpg'},
        {id: '7', comment:'音声操作：「二番」なるメニュー番号を言います。→玉置浩二の「行かないで」が演奏されます。', title: 'Screenshot_20200708_192831_com.hiroict.talkai.cast.smarthome', type:'jpg'},
      
      ],
      description: [
         {
          id: '1.1',
	      title: '説明',
	      descriptions: [
	           'カラオケは、ダンスと同様に音楽に合わせて歌うものです。',
	           'カラオケは、カラオケ動画の音楽に合わせて、正確に歌えるように何度も練習をする必要があります。',
	           'カラオケは、まず「歌詞」を覚え、歌手の真似をして練習して、「歌詞」やリスムが暗記できるように練習する必要があります。',
	           '「トークA愛 for お稽古」は、カラオケ動画に合わせて、何度も練習できる機能を提供します。',
	       ],
         },
         {
	      id: '1.2',
	      title: '操作例',
	      descriptions: [
	           '【手動の場合】',
	           '①アプリを起動します。',
	           '②最初のメニュー画面を表示します。',
	           '③左側のメニューで「カラオケ動画（男性）→玉置浩二」を選択します。',
	           '④右側のメニューで「カラオケ動画（男性）→玉置浩二→行かないで」を選択します。',
	           '⑤「行かないで」が演奏されます。',
	           '⑥「行かないで」の演奏に合わせて、カラオケの練習を開始します。',
	           '【音声の場合】',
	           '①アプリを起動します。',
	           '②音声で「行かないで」と言う「Wakeup Word」を言います。',
	           '③「お話ください」と言うダイヤログが表示されるので、音声で「行かないで」と言います。',
	           '④ダイヤログに「ナチュラル スピン ターン」を含むコンテンツ一覧が表示されるので、音声で「二番」と言います。',
	           '⑤「ナチュラル スピン ターン 群馬県の社交ダンス教室」が演奏されます。',
	           '⑥「ナチュラル スピン ターン 群馬県の社交ダンス教室」の動画を見て、練習を開始します。',
	           '⑦「Natural Spin Turn」の文字による説明は「歌詞」ボタンを押します。',
	           '⑧「Natural Spin Turn」の音声による説明は「歌詞（音声）」ボタンを押します。',
	      ],
	   }],
    },
  };
  product_4:Album = {
    player : '製品紹介',
    title: 'スケジュール機能',
    url : 'http://www.hiroict.com/files/talkai/ビデオ/トークA愛/製品紹介/',
    videoUrl : 'http://www.hiroict.com/files/talkai/ビデオ/トークA愛/トークA/ダンス教習ビデオ/チャチャチャ/',
    items: [
        {id: '1', comment:'トークAのルンバ（初級）', title: 'VID_20191116_133356', type:'mp4'},
        {id: '2', comment:'トークAのルンバ（初級）', title: 'VID_20191116_133758', type:'mp4'},
           ],
    comment:{
      id: '1',
      title:'スケジュール機能の利用',
      pictures: [
        {id: '1', comment:'手動操作：最初の画面（左）で「その他→健康」を選択します。', title: 'Screenshot_20200708_202916_com.hiroict.talkai.cast.smarthome', type:'jpg'},
        {id: '2', comment:'手動操作：最初の画面（右）で「その他→健康→アプリケーション→Schedule」を選択します。', title: 'Screenshot_20200708_202940_com.hiroict.talkai.cast.smarthome', type:'jpg'},
        {id: '3', comment:'手動操作：「Schedule」画面が表示されるので、「新規作成」ボタンを押します。', title: 'Screenshot_20200708_202955_com.hiroict.talkai.cast.smarthome', type:'jpg'},
        {id: '4', comment:'手動操作：週単位の繰り返しダイアログが表示されるので「毎日」を選択して「OK」ボタンを押します。', title: 'Screenshot_20200708_203011_com.hiroict.talkai.cast.smarthome', type:'jpg'},
        {id: '5', comment:'手動操作：「Schedule」編集画面が表示されるので、必要な項目を入力して「スケジュール登録」ボタンを押します。', title: 'Screenshot_20200708_203054_com.hiroict.talkai.cast.smarthome', type:'jpg'},
        {id: '6', comment:'手動操作：「Schedule」登録確認ダイヤログが表示されるので、「はい」ボタンを押します。', title: 'Screenshot_20200708_203105_com.hiroict.talkai.cast.smarthome', type:'jpg'},
        {id: '7', comment:'手動操作：週単位の繰り返しダイアログで「毎日」を選択したので、毎日、指定時間になると「音声会話」が開始されます。', title: 'Screenshot_20200708_203202_com.hiroict.talkai.cast.smarthome', type:'jpg'},
      
      ],
      description: [
         {
          id: '1.1',
	      title: '説明',
	      descriptions: [
	           'スケジュール機能は、指定された時間になると「音声会話」や「動画や音楽の演奏」を開始します。',
	           'スケジュール機能は、「毎日」「週単位（日曜日から土曜日）」「指定日のみ」のいずれかを指定できます。',
	           'スケジュール機能の「音声会話」機能は、①会話の開始、②注意喚起、③先行連鎖、④情報伝達、⑤対話の終了　の5つの文言で構成されます。',
	           'スケジュール機能の「音声会話」機能は、②注意喚起、④情報伝達　の２つの文言の時に、話者が音声応答ができます。',
	           'スケジュール機能の「動画や音楽の演奏」機能は、現在、1コンテンツのみ指定できます。',
	           '「トークA愛 for お稽古」は、スケジュール機能を活用して、何度も練習できる機能を提供します。',
	       ],
         },
         {
          id: '1.2',
	      title: '「音声会話」結果のメール通報機能',
	      descriptions: [
	           'スケジュール機能の「音声会話」結果は、以下のように指定したメールに通報する事ができます。',
	           '【メールのタイトル】',
	           '渡辺　透さん: 情報支援(2016-12-31 08:24:00)】',
	           '【メールの本文】',
	           '2020-06-28 08:24:49 システム: 渡辺　透さん',
	           '2020-06-28 08:24:52 システム: おはようございます。今日は、2020年6月28日8時24分49秒です。',
	           '2020-06-28 08:25:05 話者: おはよう',
	           '2020-06-28 08:25:05 システム: 今日は、デーサービスの日です。',
	           '2020-06-28 08:25:08 システム: 12時にお迎えの車が来ます。',
	           '2020-06-28 08:25:14 話者: 分かりました',
	           '2020-06-28 08:25:14 システム: よろしくお願いします。',
	       ],
         },
         {
	      id: '1.3',
	      title: '操作例（スケジュールの設定）',
	      descriptions: [
	           '【手動の場合】',
	           '①アプリを起動します。',
	           '②最初のメニュー画面を表示します。',
	           '③左側のメニューで「その他→健康」を選択します。',
	           '④右側のメニューで「その他→健康→アプリケーション→Schedule」を選択します。',
	           '⑤「Schedule」画面が表示されるので、「新規作成」ボタンを押します。',
	           '⑥週単位の繰り返しダイアログが表示されるので「毎日」を選択して「OK」ボタンを押します。',
	           '⑦「Schedule」編集画面が表示されるので、必要な項目を入力して「スケジュール登録」ボタンを押します。',
	           '⑧「Schedule」登録確認ダイヤログが表示されるので、「はい」ボタンを押します。',
	           '⑨週単位の繰り返しダイアログで「毎日」を選択したので、毎日、指定時間になると「音声会話」が開始されます。',
	           '【音声の場合】',
	           'まだ未サポートです。',
	      ],
	   }],
    },
  };
 
  /*
  album_1:Album = {
    player : 'ダンス教習ビデオ',
    title: 'ルンバ',
    url : 'http://www.hiroict.com/files/talkai/ビデオ/トークA愛/トークA/ダンス教習ビデオ/',
    videoUrl : 'http://www.hiroict.com/files/talkai/ビデオ/トークA愛/トークA/ダンス教習ビデオ/ルンバ/',
    items: [
        {id: '1', comment:'トークAのルンバ（初級）', title: 'VID_20191116_133012', type:'mp4'},
           ],
    comment:{
      title:'トークＡにおけるルンバのアルガメーション',
      pictures: [
        {id: '1', comment:'ダンスの練習の例', title: 'Screenshot_20200708_084738_com.hiroict.talkai.cast.smarthome', type:'jpg'},
      ],
      description: [{
	      id: '1',
	      title: '1',
	      descriptions: ['Open Jip Twist(2341 2341 O→F)',
	           'Hockey Stick（2341 2341 F→O）',
	           'Open Jip Twist(2341 2341 O→F)',
	           'Alemana（2341 2341 F→O）',
	           'Opening Out（2341 2341 O→F）',
	           'Hockey Stick（2341 2341 F→O）',
	           'New York to Left Side Position（2341 C→C）',
	           'New York to Right Side Position（2341 C→C）',
	           'New York to Left Side Position（2341 C→C）',
	           'New York to Right Side Position（2341 C→C）',
	           'Spot Turn to Left（2341 C→O）',
	           'マンボの足1?（2341 2341 O→T）:右手で女性を握り左足を出す。右手で女性を左回転させる',
	           'マンボの足2?（2341 2341 T→T）:左手を腰に置く。右手で女性を右回転させる。',
	           'マンボの足3?（2341 2341 T→T）:左手を腰に置く。右手で女性を左回転させ、両手を握る。',
	           'マンボの足4?（2341 2341 T→T）:両手を握りながら左足を前に出す。右足を下げる。',
	           'マンボの足5?（2341 2341 T→O）:両手を握りながら左足を横に出す。右手で女性を左回転させて正対する。',
	           'マンボの足6?（2341 2341 O→C）:左を握りながら左足を前に出す。右足を下げ次に左足を前に出す。',
	           'Natural Top（2341 2341 2341 C→C）',
	           'Rope Spinning（2341 2341 C→Ｔ（片手））',
	           'Sliding Doors（2341 2341 2341 2341 2341 F→T（右手））',
	           'マンボの足1?の後半（2341 C→T（片手））',
	           'Circular Hip Twist（2341 2341 2341 2341 C→F）',
	           'チェックして右手を上げる（2341 2341 2341 F→C）',
	           'Three Alamanas（2341 2341 2341 2341 F→C）',
	           'Three Threes（2341 2341 2341 2341 C→C）',
	           'Opening Out to the Right and Left（2341 2341 C→C）',
	        ],
	    }],
    },
  };
  album_2:Album = {
    player : 'ダンス教習ビデオ',
    title: 'チャチャチャ',
    url : 'http://www.hiroict.com/files/talkai/ビデオ/トークA愛/トークA/ダンス教習ビデオ/',
    videoUrl : 'http://www.hiroict.com/files/talkai/ビデオ/トークA愛/トークA/ダンス教習ビデオ/ルンバ/',
    items: [{id: '1', comment:'トークAのチャチャチャ（初級）1', title: 'VID_20191116_133356', type:'mp4'},
            {id: '2', comment:'トークAのチャチャチャ（初級）2', title: 'VID_20191116_133758', type:'mp4'},
           ],
    comment:{
      title:'トークＡにおけるチャチャチャのアルガメーション',
      pictures: [
        {id: '1', comment:'ダンスの練習の例', title: 'Screenshot_20200708_084738_com.hiroict.talkai.cast.smarthome', type:'jpg'},
      ],
      description: [{
	      id: '1',
	      title: '1',
	      descriptions: ['側屈を行うには肩甲骨の動きが重要らしい。',
	           '肩甲骨の動きで背骨をS型に動かして、頭の位置を動かさないように調整するらしい。',
	           'つまり、頭の位置を動かさないようにするには肩甲骨を使う必要がある訳だ。',
	           'しかし、老化した体は、肩甲骨がサビ付いている。',
	           'ダンサー裕美様の教えに従って、肩甲骨を動かして側屈運動を行おう。',
	      ],
       }],
    },
  };          
  */
  
  albums:Array<Album>;
  
  comments1:Comment = {
      id: '1',
      title: '「トークA愛」シリーズの紹介',
      pictures: [
        {id: '1', comment:'ダンスの練習の例', title: 'Screenshot_20200708_084738_com.hiroict.talkai.cast.smarthome', type:'jpg'},
      ],
      description: [
        {
	      id: '1.1',
	      title: '様々な機器で動く「トークA愛」シリーズ',
          descriptions:[
           '「トークA愛 for お稽古」は、「トークA愛」シリーズのアプリケーションの一つで、「Androidタブレット」上で動きます。',
           '「トークA愛」シリーズは、クラウド側のアプリケーションと端末側のアプリケーションで構成されます。',
           '「トークA愛」シリーズのクラウド側のアプリケーションは、Googleの「firebase」環境で動きます。',
           '「トークA愛」シリーズの固定端末側のアプリケーションは、「Google Nest Hub Max」「Google Nest Mini」上で動きます。',
           '「トークA愛」シリーズのモバイル端末側のアプリケーションが、「トークA愛 for お稽古」であり「Androidタブレット」上で動きます。',
          ],
        },
        {
	      id: '1.2',
	      title: '「トークA愛」シリーズの住宅内での利用例',
          descriptions:[
           '「トークA愛 for お稽古」は、「Google Nest Hub Max」「Google Nest Mini」「Google Chromecast」の設定を行います。',
           '「Google Nest WiFi」を住居内WiFiネットワークとして設置します。',
           '「Google Nest Hub Max」は、居間に設置します。',
           '「Google Nest Mini」は、「洗面所」と「トイレ」に設置します。',
           '「Google Chromecast」は、「テレビ」にHDMIインターフェイスで接続します。',
          ],
        },
        {
	      id: '1.3',
	      title: '「トークA愛」シリーズの課題',
          descriptions:[
           '「トークA愛 for お稽古」の「Wakeup Word検出機能」は、「Android Speech Recognizer機能」を使用していますが、入力可能を示す音を出すので別のAPIを使う必要があります。',
           '「トークA愛 for お稽古」の「Schedule機能」は、「Service化」してバックグラウンドで動かす必要があります。',
           '「トークA愛 for お稽古」の「Schedule機能」は、音声入力でスケジュールの設定ができるようにする必要があります。',
           '「トークA愛 for お稽古」の「Youtubコンテンツ演奏機能」は、「Video ID」を利用者が編集できるようにする必要があります。',
           '「トークA愛 for お稽古」の「ローカルコンテンツ」を利用者がインストール・編集できるようにする必要があります。',
           '「トークA愛 for お稽古」の「スケジュールで自動コンテンツ演奏」機能は、複数のコンテンツを指定できるようにする必要があります。',
           '「Google Chromecast」機能を有効利用する必要があります。',
          ],
        },
       ],
  }; // end of comments_1
  
  comments2:Comment = {
      id: '2',
      title: '「トークA愛 for お稽古」の特徴',
      pictures: [
        {id: '1', comment:'ダンスの練習の例', title: 'Screenshot_20200708_084738_com.hiroict.talkai.cast.smarthome', type:'jpg'},
      ],
      description: [
        {
	      id: '2.1',
	      title: '老人の老人による老人のためのタブレットアプり',
          descriptions:[
           '住宅内での「Smart Home」機能をサポートし、「空間知能化」を支援します。',
           '高齢者の「ダンス」「カラオケ」「英語」などの「お稽古ごと」を支援します。',
           '独居高齢者と独居高齢者を見守る人とのコミュニケーションを行うためのツールとして利用できます。',
           '机上の空論ではなく、実際に様々な環境の高齢者に使ってもらい、高齢者のため使いやすい端末を目指します。',
          ],
        },
        {
	      id: '2.2',
	      title: '「Google Nest Hub Max」用の「DialogFlow」アプリと同等の機能を目指す',
          descriptions:[
           '以下のような「Google Nest Hub Max」で出来ることを「Androidタブレット」上で行います。',
           '「OK Google」に続いて「ダンスの練習」と音声で指示します。',
           '「ダンスの練習」用HTMLアプリが起動されたら「ワルツ」と音声で指示します。',
           '「ワルツ」の曲が繰り返し演奏されるので、それに合わせて踊ります。また、演奏回数をカウントします。',
           '「ワルツ」の曲で1曲を踊りの練習を行うと、「OK Google」に続いて「もう一度」と音声で指示します。',
           'このようにして、同じ「ワルツ」の曲で何曲も踊ることができます。',
          ],
        },
      ],
  }; // end of comments_2

  comments3:Comment = {
      id: '3',
  	  title: '「トークA愛 for お稽古」の利用例',
      pictures: [
       {id: '1', comment:'ダンスの練習の例', title: 'Screenshot_20200708_084738_com.hiroict.talkai.cast.smarthome', type:'jpg'},
      ],
      description: [
        {
	      id: '3.1',
	      title: 'お稽古の好きな人向け',
	      descriptions:[
           '携帯可能なAndroidタブレットを使用して、高齢者の「ダンス」「カラオケ」「英語」などの「お稽古ごと」を支援します。',
           '「ダンス」の「お稽古ごと」機能を使用すると、社交ダンスの技能が通常より短い期間で習得できます。',
           '「カラオケ」の「お稽古ごと」機能を使用すること、カラオケ店での「精密採点」で高得点を出すことができます。',
           '「英語」の「お稽古ごと」機能を使用すると、英語の発音機能とヒアリング機能を向上させることができます。',
          ],
        },
        {
	      id: '3.2',
	      title: '独居高齢者向け',
          descriptions:[
           '居間に設置された「Google Nest Hub Max」で、「写真」「音楽」「動画」を楽しむ事ができます。',
           '「Google Nest Hub Max」のテレビ電話機能（Duo）を使用して、見守る人や孫など家族や友人とコミュニケーションを行う事ができます。',
           '「Google Chromecast」を使用することで「Google Nest Hub Max」の画面を「テレビ」に表示することができます。',
           '「Google Nest Hub Max」から、その時間になると「スケジュール情報」などを音声で聞くことができます。',
           '「洗面所」と「トイレ」に設置された「Google Nest Mini」を使用して、「緊急電話」をすることができます。',
          ],
         },
         {
	      id: '3.3',
	      title: '見守り者',
	      descriptions:[
	           '「Google Nest Hub Max」が独居高齢者をカメラと音声で見守りをする事ができます。',
	           '「洗面所」と「トイレ」に設置された「Google Nest Mini」を使用して、独居高齢者と「緊急電話」をすることができます。',
	           'オプションで人感センサー「M5StickC PIR HAT」を使用して、独居高齢者の居場所を把握する事ができます。',
	      ],
	     },
         {
	      id: '3.4',
	      title: '自宅待機者',
		  descriptions:[
		           '居間に設置された「Google Nest Hub Max」で、「音声」による「写真」「Webページ」「動画」などの各種情報を得る事ができます。',
		           'オプションで「Google Nest Hub Max」で、会社の上司や同僚と「テレビ電話」で会議を行う事ができます。',
		           'オプションで「Google Nest Hub Max」の画面を「Google Chromecast」で「テレビ」に表示することができます。',
		           'オプションで「Google Nest Hub Max」から、仕事の「スケジュール」を設定したり、仕事の進捗を確認することができます。',
		  ],
	    },
      ],
  }; // end of comments_3


  comments:Array<Comment>;
    
  created () {
    this.comments = [this.comments1, this.comments2, this.comments3];
    this.albums = [this.product_1, this.product_2, this.product_3, this.product_4/*this.album_1, this.album_2*/];
    this.firstVideo();
    
  }

  previousVideo() {
    window.console.log("previousVideo() 1.this.albumIndex: " + this.albumIndex);
    this.videoIndex --
    if (this.videoIndex < 0) {
      this.videoIndex = this.albums[this.albumIndex].items.length - 1
    }
    this.albumTitle = this.albums[this.albumIndex].title
    //this.videoSrc = this.albums[this.albumIndex].url + this.albums[this.albumIndex].title + '/' + this.albums[this.albumIndex].items[this.videoIndex].title + '.' + this.albums[this.albumIndex].items[this.videoIndex].type
    this.videoSrc = this.albums[this.albumIndex].videoUrl + this.albums[this.albumIndex].items[this.videoIndex].title + '.' + this.albums[this.albumIndex].items[this.videoIndex].type
    this.videoTitle = this.albums[this.albumIndex].items[this.videoIndex].title
    this.videoComment = this.albums[this.albumIndex].items[this.videoIndex].comment
    this.pictureUrl = this.albums[this.albumIndex].url + this.albums[this.albumIndex].title + '/';
  }
  firstVideo() {
    window.console.log("firstVideo() 1.this.albumIndex: " + this.albumIndex);
    this.albumIndex = 0
    this.videoIndex = 0
    this.albumTitle = this.albums[this.albumIndex].title
    //this.videoSrc = this.albums[this.albumIndex].url + this.albums[this.albumIndex].title + '/' + this.albums[this.albumIndex].items[this.videoIndex].title + '.' + this.albums[this.albumIndex].items[this.videoIndex].type
    this.videoSrc = this.albums[this.albumIndex].videoUrl + this.albums[this.albumIndex].items[this.videoIndex].title + '.' + this.albums[this.albumIndex].items[this.videoIndex].type
    this.videoTitle = this.albums[this.albumIndex].items[this.videoIndex].title
    this.videoComment = this.albums[this.albumIndex].items[this.videoIndex].comment
    this.pictureUrl = this.albums[this.albumIndex].url + this.albums[this.albumIndex].title + '/';
  }
  nextVideo() {
    window.console.log("nextVideo() 1.this.albumIndex: " + this.albumIndex);
    this.videoIndex ++
    if (this.videoIndex > this.albums[this.albumIndex].items.length - 1) {
      this.videoIndex = 0
    }
    this.albumTitle = this.albums[this.albumIndex].title
    //this.videoSrc = this.albums[this.albumIndex].url + this.albums[this.albumIndex].title + '/' + this.albums[this.albumIndex].items[this.videoIndex].title + '.' + this.albums[this.albumIndex].items[this.videoIndex].type
    this.videoSrc = this.albums[this.albumIndex].videoUrl + this.albums[this.albumIndex].items[this.videoIndex].title + '.' + this.albums[this.albumIndex].items[this.videoIndex].type
    this.videoTitle = this.albums[this.albumIndex].items[this.videoIndex].title
    this.videoComment = this.albums[this.albumIndex].items[this.videoIndex].comment
    this.pictureUrl = this.albums[this.albumIndex].url + this.albums[this.albumIndex].title + '/';
    window.console.log("nextVideo() 2.videoSrc: " + this.videoSrc);
  }
  selectVideo(index:number) {
    window.console.log("selectVideo() 1.index: " + index);
    this.albumIndex = index
    this.videoIndex = 0
    window.console.log("selectVideo() 2.url: " + this.albums[this.albumIndex].url);
    window.console.log("selectVideo() 3.title: " + this.albums[this.albumIndex].title);
    window.console.log("selectVideo() 4.title2: " + this.albums[this.albumIndex].items[this.videoIndex].title);
    this.albumTitle = this.albums[this.albumIndex].title
    //this.videoSrc = this.albums[this.albumIndex].url + this.albums[this.albumIndex].title + '/' + this.albums[this.albumIndex].items[this.videoIndex].title + '.' + this.albums[this.albumIndex].items[this.videoIndex].type
    this.videoSrc = this.albums[this.albumIndex].videoUrl + this.albums[this.albumIndex].items[this.videoIndex].title + '.' + this.albums[this.albumIndex].items[this.videoIndex].type
    window.console.log("selectVideo() 5.videoSrc: " + this.videoSrc);
    this.videoTitle = this.albums[this.albumIndex].items[this.videoIndex].title
    this.videoComment = this.albums[this.albumIndex].items[this.videoIndex].comment
    this.pictureUrl = this.albums[this.albumIndex].url + this.albums[this.albumIndex].title + '/';
  }
}
/*
export default {
  name: 'ProductWorld',
  props: {
    msg: String
  },
  data() {
    return {
      videoSrc: 'http://www.hiroict.com/files/talkai/ビデオ/トークA愛/トークA/ダンス教習ビデオ/ルンバ/VID_20191116_133012.mp4',
      //videoId1: 'mfhGUK13D3g',
      videoId2: 'ibuWJv6ncDg',
      //videoId3: '-DBmZqeww0E',
      comments1: {
        title: 'トークA愛の特徴',
        items:[
               '「トークA愛」は、独居高齢者と独居高齢者を見守る人とのコミュニケーションを行うためのツールです。',
               '「トークA愛」は、クラウド側のアプリケーションと端末側のアプリケーションで構成されます。',
               '「トークA愛」のクラウド側のアプリケーションは、Googleの「firebase」環境で動きます。',
               '「トークA愛」の固定端末側のアプリケーションは、「Google Nest Hub Max」「Google Nest Mini」上で動きます。',
               '「トークA愛」のモバイル端末側のアプリケーションは、「Androidタブレット」上で動きます。',
              ],
      }, // end of comments_1
      
      comments2: {
        title: 'トークA愛の機器構成例',
        items:[
               '「Google Nest WiFi」を住居内WiFiネットワークとして設置します。',
               '「Google Nest Hub Max」は、居間に設置します。',
               '「Google Nest Mini」は、「洗面所」と「トイレ」に設置します。',
               '「Google Chromecast」は、「テレビ」にHDMIインターフェイスで接続します。',
               '「Androidタブレット」は、「Google Nest Hub Max」「Google Nest Mini」「Google Chromecast」の設定を行います。',
              ],
      }, // end of comments_2

      comments3: {
        title: 'トークA愛の利用例（お稽古の好きな人）',
        items:[
               '携帯可能なAndroidタブレットを使用して、「カラオケ」「ダンス」「英語の発音」の練習をする事ができます。',
               '「Google Nest Hub Max」のテレビ電話機能（Duo）を使用して、見守る人や孫など家族や友人とコミュニケーションを行う事ができます。',
               '「Google Chromecast」を使用することで「Google Nest Hub Max」の画面を「テレビ」に表示することができます。',
               '「Google Nest Hub Max」から、その時間になると「スケジュール情報」などを音声で聞くことができます。',
               '「洗面所」と「トイレ」に設置された「Google Nest Mini」を使用して、「緊急電話」をすることができます。',
              ],
      }, // end of comments_3

      comments4: {
        title: 'トークA愛の利用例（独居高齢者）',
        items:[
               '居間に設置された「Google Nest Hub Max」で、「写真」「音楽」「動画」を楽しむ事ができます。',
               '「Google Nest Hub Max」のテレビ電話機能（Duo）を使用して、見守る人や孫など家族や友人とコミュニケーションを行う事ができます。',
               '「Google Chromecast」を使用することで「Google Nest Hub Max」の画面を「テレビ」に表示することができます。',
               '「Google Nest Hub Max」から、その時間になると「スケジュール情報」などを音声で聞くことができます。',
               '「洗面所」と「トイレ」に設置された「Google Nest Mini」を使用して、「緊急電話」をすることができます。',
              ],
      }, // end of comments_4

      comments5: {
        title: 'トークA愛の利用例（見守り者）',
        items:[
               '「Google Nest Hub Max」が独居高齢者をカメラと音声で見守りをする事ができます。',
               '「洗面所」と「トイレ」に設置された「Google Nest Mini」を使用して、独居高齢者と「緊急電話」をすることができます。',
               'オプションで人感センサー「M5StickC PIR HAT」を使用して、独居高齢者の居場所を把握する事ができます。',
              ],
      }, // end of comments_5

      comments6: {
        title: 'トークA愛の利用例（自宅待機者）',
        items:[
               '居間に設置された「Google Nest Hub Max」で、「音声」による「写真」「Webページ」「動画」などの各種情報を得る事ができます。',
               'オプションで「Google Nest Hub Max」で、会社の上司や同僚と「テレビ電話」で会議を行う事ができます。',
               'オプションで「Google Nest Hub Max」の画面を「Google Chromecast」で「テレビ」に表示することができます。',
               'オプションで「Google Nest Hub Max」から、仕事の「スケジュール」を設定したり、仕事の進捗を確認することができます。',
              ],
      }, // end of comments_6

      comments: [],
    } // end of return
  }, // end of data()
  
  created () {
    this.comments = [this.comments1, this.comments2, this.comments3, this.comments4, this.comments5, this.comments6]
    //this.firstVideo()
  },
  
} // end of default
*/
